import React from "react"

import CustomEvent from "@root/components/CustomEvent"
import { useAppDispatch } from "@root/store"
import { emitChannelCustomEvent } from "@root/store/thunks"
import { CustomEvent as CustomEventType } from "@root/store/types"

const ChannelCustomEvent: React.FC = () => {
  const dispatch = useAppDispatch()

  const createEvent = React.useCallback(
    (event: CustomEventType) => dispatch(emitChannelCustomEvent(event)),
    [dispatch]
  )

  return <CustomEvent onCreateCustomEvent={createEvent} />
}

export default ChannelCustomEvent
